import type { JSX } from 'react';

/*
 * Die goAVA-Wortmarke, aus goLogo-light.svg uebernommen (Adobe-Illustrator-Export,
 * viewBox 150x45). Die Pfade sind unveraendert; geaendert ist nur die Farbe:
 * statt eines festen Weiss steht hier currentColor, damit dieselbe Marke auf
 * hellem und dunklem Grund funktioniert, ohne zwei Dateien zu pflegen.
 *
 * Inline und nicht als Datei: 2 KB, dafuer keine zusaetzliche Anfrage und kein
 * Aufblitzen beim Laden. Eine gezeichnete Wortmarke laesst sich nicht aus Text
 * nachbauen — deshalb liegt sie als Vektor hier und nicht als Schriftzug.
 */

/** Die Buchstaben "go". Auch allein verwendbar, etwa als Zeichen. */
const GO = (
  <>
    <path d="M3.7,41.2h27.1v-5.5H9.1v-7.4c2.4,2.2,5.5,3.4,8.7,3.4,7.1,0,12.9-5.8,12.9-12.9,0-3.6-1.5-7.1-4.2-9.6h4.2V3.8h-5.5v4.5c-2.2-1.5-4.8-2.4-7.4-2.4-7.1,0-12.9,5.8-12.9,12.9,0,3.1,1.1,6,3.1,8.3H3.7v14.1ZM10.5,18.8c0-4.1,3.3-7.4,7.4-7.4h0c4.1,0,7.4,3.3,7.4,7.4h0c0,4.1-3.3,7.4-7.4,7.4h0c-4.1,0-7.4-3.3-7.4-7.4h0" />
    <path d="M59.2,18.8c0-7.1-5.8-12.9-12.9-12.9-7.1,0-12.9,5.8-12.9,12.9s5.8,12.9,12.9,12.9h0c7.1,0,12.9-5.8,12.9-12.9M53.7,18.8c0,4.1-3.3,7.4-7.4,7.4h0c-4.1,0-7.4-3.3-7.4-7.4s3.3-7.4,7.4-7.4h0c4.1,0,7.4,3.3,7.4,7.4h0" />
  </>
);

/** Die Buchstaben "ava". */
const AVA = (
  <>
    <path d="M98.8,31.8l-9.1-25.7h6.9l9.1,25.7h-6.9Z" />
    <path d="M112.7,31.8l9.1-25.7h-6.9l-9.1,25.7h6.9Z" />
    <path d="M88.9,31.8v-14.5c0-7.1-3.5-11.1-10.1-11.2h0s-11,0-11,0l-1.3,4.7h11.9s0,0,0,0c.2,0,.5,0,.7,0l-12.6,14.5c-.8.7-1.2,1.7-1.3,2.8,0,2,1.5,3.6,3.5,3.7,0,0,.1,0,.2,0h16.3s3.7,0,3.7,0ZM83.4,26.6h-9.3c-.5,0-.8-.5-.8-1,0-.2,0-.4.2-.6l9.9-11.5v13Z" />
    <path d="M146.3,31.8v-14.5c0-7.1-3.5-11.1-10.1-11.2h0s-11,0-11,0l-1.3,4.7h11.9s0,0,0,0c.2,0,.5,0,.7,0l-12.6,14.5c-.8.7-1.2,1.7-1.3,2.8,0,2,1.5,3.6,3.5,3.7,0,0,.1,0,.2,0h16.3s3.7,0,3.7,0ZM140.9,26.6h-9.3c-.5,0-.8-.5-.8-1,0-.2,0-.4.2-.6l9.9-11.5v13Z" />
  </>
);

export function Logo({ className = '' }: { className?: string }): JSX.Element {
  return (
    <svg
      viewBox="0 0 150 45"
      fill="currentColor"
      role="img"
      aria-label="goAVA"
      className={className}
    >
      {GO}
      {AVA}
    </svg>
  );
}

/**
 * Nur das "go" — fuer enge Stellen, an denen die volle Wortmarke unleserlich
 * klein wuerde.
 */
export function LogoMark({ className = '' }: { className?: string }): JSX.Element {
  return (
    <svg
      viewBox="0 0 62.9 45"
      fill="currentColor"
      role="img"
      aria-label="goAVA"
      className={className}
    >
      {GO}
    </svg>
  );
}
